/**
 * Created on 2020/7/10.
 */
import CONST from '../config';
import Tools from '../libs/utils';
import { encryptBASE64, encryptMD5, encryptAES } from '@/libs/encrypt';

/**
 * @description 商城参数签名
 * @param args
 * @return {*}
 * @constructor
 */
export default function SR (args = {}) {
  const nonceStr = Tools.generateUUID();
  const timestamp = new Date().getTime().toString();
  console.log('============请求参数：', args);
  const params = encryptBASE64(encryptAES(JSON.stringify(args), CONST.$AES_KEY));
  const sign = encryptMD5(`${CONST.$CLIENT_ID}${nonceStr}${timestamp}${params}${CONST.$SIGN_KEY}`).toUpperCase();
  // 合并签名，返回参数
  return {
    nonceStr,
    timestamp,
    params,
    sign
  };
}
